/** 
 * HELPERS
 */

const selectId = (val) => {
  if (typeof val === 'object') {
    // assume val === object
    return val?.id;
  }

  // assume val === id value
  return val;
}

const _findIndex = (items, item) => {
  const id = selectId(item);
  return items.findIndex((i) => i.id === id);
}



/** 
 * MAIN - EXPANDED ROWS
 */
const expandAllRows = (items = []) => {
  return items.reduce((acc, item, idx) => { 
    const id = selectId(item);
    acc[id] = idx + 1;
    return acc;
  }, {})
}

const expandRow = (items, expandedRowMapById, item) => { 
  const id = selectId(item);
  const idx = _findIndex(items, item);
  const clone = { ...expandedRowMapById };
  clone[id] = idx > -1 ? idx + 1 : idx; // track position (idx + 1)
  return clone;
}

const collapseRow = (expandedRowMapById, item) => {
  const id = selectId(item);
  const clone = { ...expandedRowMapById };
  delete clone[id];
  return clone;
}

const toggleRow = (items, expandedRowMapById, item) => { 
  const id = selectId(item);
  if (expandedRowMapById[id]) { 
    return collapseRow(expandedRowMapById, item);
  }
  return expandRow(items, expandedRowMapById, item);
}



/** 
 * MAIN - SELECTED SURVEYS
 */

const selectSurvey = (selectedSurveysMapById, lineAgg, survey) => {
  const lineAggId = selectId(lineAgg);
  const surveyId = selectId(survey);
  const clone = { ...selectedSurveysMapById };
  const surveys = [...(clone[lineAggId] || [])];
  clone[lineAggId] = surveys;
  surveys.push(surveyId);
  return clone;
}

const unselectSurvey = (selectedSurveysMapById, lineAgg, survey) => {
  const lineAggId = selectId(lineAgg);
  const surveyId = selectId(survey);
  const clone = { ...selectedSurveysMapById };
  const surveys = (clone[lineAggId] || []).filter(id => id !== surveyId);
  clone[lineAggId] = surveys;
  if (surveys.length === 0) { 
    delete clone[lineAggId];
  }
  return clone;
}

const toggleSelectedSurvey = (selectedSurveysMapById, lineAgg, survey) => { 
  const map = selectedSurveysMapById;
  const lineAggId = selectId(lineAgg);
  const surveyId = selectId(survey);
  const isSelected = (map[lineAggId] || []).findIndex(id => id === surveyId) > -1;
  if (isSelected) { 
    return unselectSurvey(map, lineAgg, survey);
  }
  return selectSurvey(map, lineAgg, survey);
}

export { 
  expandAllRows,
  expandRow,
  collapseRow,
  toggleRow,

  selectSurvey,
  unselectSurvey,
  toggleSelectedSurvey,
}

export default {
  selectId,

  expandAllRows,
  expandRow,
  collapseRow,
  toggleRow,

  selectSurvey,
  unselectSurvey,
  toggleSelectedSurvey,
}